angular.module("registrace", ['ngRoute', 'registraceServices', 'translation', 'common'])

.config(['$routeProvider',
	function($routeProvider) {
		$routeProvider.when('/registrace-simple', {
			templateUrl: 'registrace/tmpl/registrace-simple.tmpl.html',
			controller: 'RegistraceSimpleCtrl'
		});
		$routeProvider.when('/registrace-email-sent', {
			templateUrl: 'registrace/tmpl/registrace-email-sent.tmpl.html',
			controller: 'RegistraceEmailSentCtrl'
		});
		$routeProvider.when('/registrace', {
			templateUrl: 'registrace/tmpl/registrace.tmpl.html',
			controller: 'RegistraceCtrl'
		});
		$routeProvider.when('/dokonceni', {
			templateUrl: 'registrace/tmpl/registrace-dokonceni.tmpl.html',
			controller: 'RegistraceDokonceniCtrl'
		});
		$routeProvider.when('/ok', {
			templateUrl: 'registrace/tmpl/registrace-ok.tmpl.html',
			controller: 'RegistraceOkCtrl'
		});
		$routeProvider.otherwise({
			redirectTo: '/registrace-simple'
		});
	}
]);
angular.module("registrace")

    .controller('RegistraceCtrl', ["$scope", "$http", "$location", "api", "Registrace", "Container", function ($scope, $http, $location, api, Registrace, Container) {

        $scope.formData = {komodita:'utility'};
        $scope.blured = {};

        $scope.deaktivateApp = deaktivateApp;

        if ($scope.deaktivateApp === true || $scope.deaktivateApp === "true") {
            api.msg('Omlouváme se Vám, ale tato aplikace je dočasně nedostupná, zkuste to prosím později.', 'ERROR', 'NG-APPD', '001');
            return;
        }

        $scope.setBlured = function (elem, blured) {
            $scope.blured[elem] = blured;
        };

        $scope.isBlured = function (elem) {
            return !!$scope.blured[elem];
        };

        $scope.data = {
            customized: false,
            loading: false
        };

        var init = function () {

            if (location.search.match(/zpnd/) || location.search.match(/cdi/)) {
                api.logAnonymousAppAction('REGISTRACE-PND', '', '', '');
                $scope.data.customized = true;
                Container.setCustomized();
            } else {
                api.logAnonymousAppAction('REGISTRACE', '', '', '');
            }
        };

        init();



        $scope.processForm = function () {
            Container.setBasicInfo($scope.formData);
            $scope.data.loading = true;


            Registrace.registerStep1($scope.formData)
                .success(function (response) {

                    var message;
                    api.cleanMessages();

                    if (response && (response.loginStatus !== null) && (response.loginStatus === 0)) {
                        $scope.data.loginList = response.loginList;
                        message = {
                            type: 'WARN',
                            text: 'Zadaný login není možné použít.',
                            id: 'NG-REG',
                            num: "001"
                        };
                        api.addMessage(message);
                    } else {
                        Container.setCompany(response.company);
                        $location.path("/dokonceni");
                    }
                    $scope.data.loading = false;
                })

                .error(function (response) {
                    $scope.data.loading = false;
                });
        };
        

    }]);
angular.module("registrace")

.controller('RegistraceDokonceniCtrl', ["$scope", "$http", "$location", "api", "Registrace", "Container", function($scope, $http, $location, api, Registrace, Container) {

	$scope.deaktivateApp = deaktivateApp;

	if ($scope.deaktivateApp === true || $scope.deaktivateApp === "true") {
		api.msg('Omlouváme se Vám, ale tato aplikace je dočasně nedostupná, zkuste to prosím později.', 'ERROR', 'NG-APPD', '001');
		return;
	}

	$scope.$on('ResponseMessagesReceived', function(event, messages) {
		Container.setMessages(messages);
		$scope.messages = messages;
	});


	$scope.messages = [];
	$scope.formDataSms = {};
	$scope.formData = {};
	$scope.blured = {};
	$scope.loading = false;

	$scope.step1response = {};

	$scope.data = {
		customized: false
	};

	$scope.state = {
		sent: false,
		sending: false
	};

    $scope.emailRegex = new RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$");

	$scope.init = function() {
		api.logAnonymousAppAction('REGISTRACE', 'VIEW', 'STEP', 'Druhý krok');
		$scope.step1response.isCompany = Container.isCompany();
		$scope.data.customized = Container.getCustomized();
        Registrace.getEmailRegex().success(function(response) {
            $scope.emailRegex = new RegExp(response.data);
        }).error(function(response) {

        });

		if (Container.getMessages().length > 0) {
			$scope.step1response.messages = Container.getMessages();
		}
	};

	$scope.init();

	$scope.setBlured = function(elem, blured) {
		$scope.blured[elem] = blured;
	};

	$scope.isBlured = function(elem) {
		return !!$scope.blured[elem];
	};



	$scope.overitTelefon = function() {
		api.logAnonymousAppAction('REGISTRACE', 'SEND', 'SMS', '');
		Container.setSms($scope.formDataSms);
		$scope.state.sending = true;

		Registrace.sendSms($scope.formDataSms).success(function(response) {

				$scope.state.sending = false;
				$scope.state.sent = true;

			})
			.error(function(response) {
				$scope.state.sending = false;
			});
	};

	$scope.dokoncit = function() {
		Container.setAdvancedInfo($scope.formData);
		$scope.loading = true;

		$scope.formData.company = $scope.step1response.isCompany;

		Registrace.registerStep2($scope.formData, $scope.data.customized).success(function(response) {

			$scope.loading = false;
			$location.path("/ok");
		})

		.error(function(response) {
			$scope.loading = false;
		});
	};

}]);
angular.module("registrace")

.controller('RegistraceEmailSentCtrl', ["$scope", "$location", "$http", "api", "Container", "$window", "Registrace", function($scope, $location, $http, api, Container, $window, Registrace) {
	

    $scope.deaktivateApp = deaktivateApp;

    if ($scope.deaktivateApp === true || $scope.deaktivateApp === "true") {
        api.msg('Omlouváme se Vám, ale tato aplikace je dočasně nedostupná, zkuste to prosím později.', 'ERROR', 'NG-APPD', '001');
        return;
    }

    $scope.target = Container.getTarget();
	
	
}]);
angular.module("registrace")

.controller('RegistraceOkCtrl', ["$scope", "$location", "$http", "api", "Container", "$window", "Registrace", function($scope, $location, $http, api, Container, $window, Registrace) {

	$scope.step2response = {};
	$scope.container = {};
	$scope.loading = false;

	$scope.data = {
		customized: false
	};

    $scope.deaktivateApp = deaktivateApp;

    if ($scope.deaktivateApp === true || $scope.deaktivateApp === "true") {
        api.msg('Omlouváme se Vám, ale tato aplikace je dočasně nedostupná, zkuste to prosím později.', 'ERROR', 'NG-APPD', '001');
        return;
    }

	$scope.init = function() {
		api.logAnonymousAppAction('REGISTRACE', 'VIEW', 'STEP', 'Dokončení');
		$scope.data.customized = Container.getCustomized();
	};

	$scope.init();

	$scope.login = function() {
		api.logAnonymousAppAction('REGISTRACE', 'LOGIN', 'QUICK', '');
		$scope.loading = true;

		$scope.loginData = {
			url: "/irj/portal/prehled-uctu",
			j_user: Container.getFormDataContainer().step1.loginName,
			j_password: Container.getFormDataContainer().step2.heslo
		};

		$("#okForm").submit();
/*
		PREDELANO NA SKRYTY FORM KULI PRESMEROVANI NA HTTP A ZPET NA F5

		var _url = "/irj/portal/prehled-uctu";
		// var _url = $location.protocol() + "://" + $location.host() + ":" + $location.port() + "/irj/portal/prehled-uctu";
		var loginData = {
			login_submit: 'on',
			login_do_redirect: '1',
			no_cert_storing: 'on',
			j_authscheme: 'default',

			j_user: Container.getFormDataContainer().step1.loginName,
			j_password: Container.getFormDataContainer().step2.heslo
		};

		if ($scope.data.customized) {
			loginData.zpnd = true;
		}

		$http({
			method: 'POST',
			url: _url,
			data: $.param(loginData),
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		}).success(function(response) {
			$scope.loading = false;
			//				$('html').html(response);
			if ($scope.data.customized) {
				if (location.search.match('cezonlinet.cez.cz') || location.search.match('/petci.cezdata.corp')) {
					$window.location.href = "https://pndt.cez.cz/cezpnd/external/corporate/dashboard";
				} else {

					$window.location.href = "https://pnd.cez.cz";
				}
			} else {
				$window.location.href = _url;
			}
		});
*/
	};
}]);
angular.module("registrace")

    .controller('RegistraceSimpleCtrl', ["$scope", "$http", "$location", "api", "Registrace", "Container", function ($scope, $http, $location, api, Registrace, Container) {

        $scope.blured = {};
        $scope.deaktivateApp = deaktivateApp;
        $scope.data = {
            identificator:null,
            captcha:null,
            loading: false,
            siteKey:null,
            ref: null
        };

        if ($scope.deaktivateApp === true || $scope.deaktivateApp === "true") {
            api.msg('Omlouváme se Vám, ale tato aplikace je dočasně nedostupná, zkuste to prosím později.', 'ERROR', 'NG-APPD', '001');
            return;
        }

        var getParameterByName = function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        };

        var init = function () {
            if (location.search.match(/zpnd/) || location.search.match(/cdi/)) {
                $location.path("/registrace");
            }

            Registrace.getSiteKey().success(function (response) {
                $scope.data.siteKey = response;
            });

            var ref = getParameterByName('ref');
            if (ref) {
                $scope.data.ref = ref;
                Container.setRef(ref);
            }
        };
        init();

        $scope.setBlured = function (elem, blured) {
            $scope.blured[elem] = blured;
        };

        $scope.isBlured = function (elem) {
            return !!$scope.blured[elem];
        };


        $scope.execCaptcha = function(){
            grecaptcha.reset();
            grecaptcha.execute();
        };
        
        $scope.processForm = function (captchaToken) {
            $scope.data.captcha = captchaToken;
            $scope.data.loading = true;
            api.cleanMessages();
            
            Registrace.registerStep0($scope.data)
                .success(function (response) {
                    $scope.data.loading = false;
                    var data = response;
                    if(data.smsSend){
                        window.location.href = '/irj/portal/anonymous/dokonceni-registrace?type=SMS&org='+data.org + '&target=' + data.target + ($scope.data.ref ? '&ref=' + $scope.data.ref : '');
                    } else if(data.emailSend){
                        Container.setTarget(data.target);
                        $location.path("/registrace-email-sent");
                    } else {
                        $location.path("/registrace");
                    }
                })

                .error(function (response) {
                    $scope.data.loading = false;
                });
        };

        window.processForm =  $scope.processForm;

    }]);
angular.module('registraceServices', [])

.factory('Registrace', ["$http", "settings", function($http, settings) {

	var baseUrl = settings.g_anonymousRestUrl + "/registrace";

	return {
		registerStep0:function(data){
			return $http({
				method: 'POST',
				url: baseUrl + '/search-op',
				data: {'identificator':data.identificator,'captcha':data.captcha,'ref':data.ref},
				headers: {
					'Content-Type': 'application/json'
				}
			});
		},
		registerStep1: function(formData) {

			return $http({
				method: 'POST',
				url: baseUrl + '/basic-info',
				data: formData,
				headers: {
					'Content-Type': 'application/json'
				}
			});
		},
		registerStep2: function(formData) {

			return $http({
				method: 'POST',
				url: baseUrl + '/advanced-info',
				data: formData,
				headers: {
					'Content-Type': 'application/json'
				}
			});
		},
		sendSms: function(formData) {

			return $http({
				method: 'POST',
				url: baseUrl + '/sms',
				data: formData,
				headers: {
					'Content-Type': 'application/json'
				}
			});
		},
        getEmailRegex: function() {

            return $http({
                method: 'GET',
                url: baseUrl + '/email-regex',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        },
		getSiteKey: function() {
			return $http({
				method: 'GET',
				url: baseUrl + '/site-key',
				headers: {
					'Content-Type': 'application/json'
				}
			});
		}
	};
}])

.factory('Container', function() {
	var messages = {};
	var isCompany = false;
	var loginList = [];
	var formDataContainer = {
		step1: {},
		step2: {},
		sms: {}
	};
	var customized = false;
	var target = null;
    var ref = null;
	return {
		getMessages: function() {
			return messages;
		},
		setMessages: function(msgs) {
			messages = msgs;
		},
		isCompany: function() {
			return isCompany;
		},
		setCompany: function(bool) {
			isCompany = bool;
		},
		getLoginList: function() {
			return loginList;
		},
		setLoginList: function(list) {
			loginList = list;
		},
		setBasicInfo: function(formData) {
			formDataContainer.step1 = formData;
		},
		setAdvancedInfo: function(formData) {
			formDataContainer.step2 = formData;
		},
		setSms: function(formData) {
			formDataContainer.sms = formData;
		},
		getFormDataContainer: function() {
			return formDataContainer;
		},
		setCustomized: function() {
			customized = true;
		},
		getCustomized: function() {
			return customized;
		},
		setTarget: function(value) {
			target = value;
		},
		getTarget: function() {
			return target;
		},
		getRef: function () {
            return ref;
        },
        setRef: function (data) {
            ref = data;
        }

	};
});
angular.module("registrace").run(["$templateCache", function($templateCache) {$templateCache.put("registrace/tmpl/registrace-dokonceni.tmpl.html","<div class=\"esco-page registration-page registration-completion-page\">\n<div messages></div>\n<h1 data-ng-if=\"deaktivateApp !== true && deaktivateApp !== \'true\'\">{{\'SU_REGISTRACE_DOKONCIT_LABEL\' | translate}}</h1>\n\n<div custom-block data-ng-if=\"deaktivateApp !== true && deaktivateApp !== \'true\'\"></div>\n\n<form name=\"userForm\" class=\"form-horizontal\" role=\"form\" data-ng-submit=\"dokoncit()\" novalidate data-ng-if=\"deaktivateApp !== true && deaktivateApp !== \'true\'\">\n  <h2>{{\'SU_REGISTRACE_DOKONCIT_OVERENI\' | translate}}</h2>\n  <div data-ng-if=\"step1response.isCompany == false\" class=\"form-group\" data-ng-class=\"{ \'has-error\' : userForm.datumNarozeni.$invalid && !userForm.datumNarozeni.$pristine }\">\n    <label for=\"datumNarozeni\" class=\"col-xs-12 control-label\">{{\'SU_REGISTRACE_DATUMNAROZENI\' | translate}}</label>\n    <div class=\"col-xs-8\">\n      <input type=\"text\" class=\"form-control\" name=\"datumNarozeni\" id=\"datumNarozeni\" placeholder=\"DD.MM.RRRR\" data-ng-model=\"formData.datumNarozeni\" data-ng-pattern=\"/^(0[1-9]|[12][0-9]|3[01])\\.(0[1-9]|1[012])\\.(19|20)\\d\\d$/\" data-ng-blur=\"setBlured(\'datumNarozeni\', true)\" data-ng-focus=\"setBlured(\'datumNarozeni\', false)\" required />\n      <p data-ng-show=\"userForm.datumNarozeni.$error.pattern && isBlured(\'datumNarozeni\')\" class=\"help-block\">{{\'SU_REGISTRACE_DATUMNAROZENI_ERROR\' | translate}}</p>\n    </div>\n    <small>{{\'SU_REGISTRACE_DATUMNAROZENI_INFO\' | translate}}</small>\n  </div>\n  <div data-ng-if=\"step1response.isCompany == true\" class=\"form-group\" data-ng-class=\"{ \'has-error\' : userForm.ico.$invalid && !userForm.ico.$pristine }\">\n    <label for=\"ico\" class=\"col-xs-12 control-label\">{{\'SU_REGISTRACE_ICO\' | translate}}</label>\n    <div class=\"col-xs-8\">\n      <input type=\"text\" class=\"form-control\" name=\"ico\" id=\"ico\" placeholder=\"{{\'SU_REGISTRACE_ICO\' | translate}}\" data-ng-model=\"formData.ico\" data-ng-pattern=\"/^[\\w\\W]{1,100}$/\" data-ng-blur=\"setBlured(\'ico\', true)\" data-ng-focus=\"setBlured(\'ico\', false)\" required />\n      <p data-ng-show=\"userForm.ico.$error.pattern && isBlured(\'ico\')\" class=\"help-block\">{{\'SU_REGISTRACE_ICO_ERROR\' | translate}}</p>\n    </div>\n    <small>{{\'SU_REGISTRACE_ICO_INFO\' |translate}}</small>\n  </div>\n  \n  <div class=\"form-group\" data-ng-class=\"{ \'has-error\' : userForm.telefon.$invalid && !userForm.telefon.$pristine }\">\n    <label for=\"telefon\" class=\"col-xs-12 control-label\">{{\'SU_REGISTRACE_TELEFONSMS_OVERENI\' | translate}}</label>\n    <div class=\"col-xs-11\">\n      <div class=\"input-group phonePrefix\">\n        <input type=\"text\" class=\"form-control prefixInput\" name=\"telefon\" id=\"telefon\" data-ng-model=\"formDataSms.telefon\" data-ng-pattern=\"/^(\\d{3}\\s?\\d{3}\\s?\\d{3})$/\" data-ng-blur=\"setBlured(\'telefon\', true)\" data-ng-focus=\"setBlured(\'telefon\', false)\"/>\n        <p data-ng-show=\"userForm.telefon.$error.pattern && isBlured(\'telefon\')\" class=\"help-block\">{{\'SU_REGISTRACE_TELEFONSMS_ERROR\' | translate}}</p>\n        <span class=\"input-group-btn\">\n        <button class=\"btn btn-primary\" data-ng-click=\"overitTelefon()\" type=\"button\">\n          <i class=\"glyphicon glyphicon-ok\" data-ng-if=\"state.sent && !state.sending\"></i>\n          <span data-ng-if=\"state.sending\">Odesílání..</span>\n          <span data-ng-if=\"!state.sent && !state.sending\">{{\'SU_REGISTRACE_TELEFONSMS_ODESLAT\' | translate}}</span>\n        </button>\n        </span>\n      </div>\n    </div>\n    <small>{{\'SU_REGISTRACE_TELEFONSMS_INFO2\' | translate}}<br>\n    {{\'SU_REGISTRACE_TELEFONSMS_INFO3\' | translate}}</small>\n  </div>\n  <div class=\"form-group\" data-ng-class=\"{ \'has-error\' : userForm.smsKey.$invalid && !userForm.smsKey.$pristine }\">\n    <label for=\"smsKey\" class=\"col-xs-12 control-label\">{{\'SU_REGISTRACE_KODSMS\' | translate}}</label>\n    <div class=\"col-xs-8\">\n      <input type=\"text\" class=\"form-control\" data-ng-model=\"formData.smsKey\" id=\"smsKey\" name=\"smsKey\" placeholder=\"{{\'SU_REGISTRACE_KODSMS\' | translate}}\" data-ng-blur=\"setBlured(\'smsKey\', true)\" data-ng-focus=\"setBlured(\'smsKey\', false)\" required />\n      <p data-ng-show=\"userForm.smsKey.$invalid && isBlured(\'smsKey\')\" class=\"help-block\">{{\'SU_REGISTRACE_KODSMS_INFO\' | translate}}</p>\n    </div>\n  </div>\n  \n  <h2 data-ng-show=\"!data.customized\">{{\'SU_REGISTRACE_NASTAVENIUCTU\' | translate}}</h2>\n  <h2 data-ng-show=\"data.customized\">{{\'SU_REGISTRACE_NASTAVENIUCTU_PND\' | translate}}</h2>\n  \n  \n  <div class=\"form-group\" data-ng-if=\"step1response.isCompany == true\" data-ng-class=\"[{ \'has-error\' : userForm.jmeno.$invalid && !userForm.jmeno.$pristine},{ \'has-error\' : userForm.prijmeni.$invalid && !userForm.prijmeni.$pristine}]\">\n    <div class=\"col-xs-3\">\n      <label for=\"jmeno\" class=\"control-label\">{{\'SU_REGISTRACE_JMENO\' | translate}}</label>\n      <div class=\"\">\n        <input type=\"text\" data-ng-model=\"formData.jmeno\" class=\"form-control\" id=\"jmeno\" placeholder=\"{{\'SU_REGISTRACE_JMENO\' | translate}}\" data-ng-blur=\"setBlured(\'jmeno\', true)\" data-ng-focus=\"setBlured(\'jmeno\', false)\" data-ng-pattern=\"/^[\\w\\W]{1,40}$/\" required>\n        <p data-ng-show=\"userForm.jmeno.$error.pattern && isBlured(\'jmeno\')\" class=\"help-block\">{{\'SU_REGISTRACE_JMENO_ERROR\' | translate}}</p>\n      </div>\n    </div>\n    <div class=\"col-xs-5\">\n      <label for=\"prijmeni\" class=\"control-label\">{{\'SU_REGISTRACE_PRIJMENI\' | translate}}</label>\n      <div class=\"\">\n        <input type=\"text\" data-ng-model=\"formData.prijmeni\" class=\"form-control\" id=\"prijmeni\" placeholder=\"{{\'SU_REGISTRACE_PRIJMENI\' | translate}}\" data-ng-blur=\"setBlured(\'prijmeni\', true)\" data-ng-focus=\"setBlured(\'prijmeni\', false)\" data-ng-pattern=\"/^[\\w\\W]{1,40}$/\" required>\n        <p data-ng-show=\"userForm.prijmeni.$error.pattern && isBlured(\'prijmeni\')\" class=\"help-block\">{{\'SU_REGISTRACE_PRIJMENI_ERROR\' | translate}}</p>\n      </div>\n    </div>\n  </div>\n  <div data-ng-if=\"step1response.isCompany == true\" class=\"form-group\" data-ng-class=\"{ \'has-error\' : userForm.datumNarozeni2.$invalid && !userForm.datumNarozeni2.$pristine }\">\n    <label for=\"datumNarozeni2\" class=\"col-xs-12 control-label\">{{\'SU_REGISTRACE_DATUMNAROZENI\' | translate}}</label>\n    <div class=\"col-xs-8\">\n      <input type=\"text\" class=\"form-control\" name=\"datumNarozeni2\" id=\"datumNarozeni2\" placeholder=\"DD.MM.RRRR\" data-ng-model=\"formData.datumNarozeni\" data-ng-pattern=\"/^(0[1-9]|[12][0-9]|3[01])\\.(0[1-9]|1[012])\\.(19|20)\\d\\d$/\" data-ng-blur=\"setBlured(\'datumNarozeni2\', true)\" data-ng-focus=\"setBlured(\'datumNarozeni2\', false)\" required />\n      <p data-ng-show=\"userForm.datumNarozeni2.$error.pattern && isBlured(\'datumNarozeni2\')\" class=\"help-block\">{{\'SU_REGISTRACE_DATUMNAROZENI_ERROR\' | translate}}</p>\n    </div>\n    <small>{{\'SU_REGISTRACE_DATUMNAROZENI_INFO\' | translate}}</small>\n  </div>\n  <div class=\"form-group\" data-ng-class=\"{ \'has-error\' : userForm.email.$invalid && !userForm.email.$pristine }\">\n    <label for=\"email\" class=\"col-xs-12 control-label\">{{\'SU_REGISTRACE_EMAIL\' | translate}}</label>\n    <div class=\"col-xs-8\">\n      <div class=\"input-group\">\n        <div class=\"input-group-addon\">@</div>\n        <input type=\"email\" class=\"form-control\" data-ng-model=\"formData.email\" name=\"email\" id=\"email\" placeholder=\"{{\'SU_REGISTRACE_EMAIL\' | translate}}\" data-ng-pattern=\"emailRegex\" data-ng-blur=\"setBlured(\'email\', true)\" data-ng-focus=\"setBlured(\'email\', false)\" required />\n      </div>\n      <p data-ng-show=\"userForm.email.$error.pattern && isBlured(\'email\')\" class=\"help-block\">{{\'SU_REGISTRACE_EMAIL_ERROR\' | translate}}</p>\n    </div>\n  </div>\n  <div class=\"form-group\" data-ng-class=\"{ \'has-error\' : userForm.password.$invalid && !userForm.password.$pristine }\">\n    <label data-ng-show=\"!data.customized\" for=\"password\" class=\"col-xs-12 control-label\">{{\'SU_REGISTRACE_HESLO\' | translate}}</label>\n    <label data-ng-show=\"data.customized\" for=\"password\" class=\"col-xs-12 control-label\">{{\'SU_REGISTRACE_HESLO_PND\' | translate}}</label>\n    <div class=\"col-xs-8\">\n      <input type=\"password\" class=\"form-control\" data-ng-model=\"formData.heslo\" id=\"password\" name=\"password\" placeholder=\"{{\'SU_REGISTRACE_HESLO_PH\' | translate}}\" data-ng-pattern=\"/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=^[a-zA-Z0-9\\._]{10,60}$)/\" data-ng-blur=\"setBlured(\'password\', true)\" data-ng-focus=\"setBlured(\'password\', false)\" required />\n      <p data-ng-show=\"userForm.password.$error.pattern && isBlured(\'password\')\" class=\"help-block\">{{\'SU_REGISTRACE_HESLO_ERROR\' | translate}}</p>\n    </div>\n    <small class=\"col-xs-9\">{{\'SU_ZMENAHESLA_HESLO_POZADAVKY\' | translate}}</small>\n  </div>\n  <div class=\"form-group\" data-ng-class=\"{ \'has-error\' : formData.heslo != formData.heslo2 && !userForm.password2.$pristine }\">\n    <label for=\"password2\" class=\"col-xs-12 control-label\">{{\'SU_REGISTRACE_HESLO_OVERENI\' | translate}}</label>\n    <div class=\"col-xs-8\">\n      <input type=\"password\" class=\"form-control\" data-ng-model=\"formData.heslo2\" id=\"password2\" name=\"password2\" placeholder=\"{{\'SU_REGISTRACE_HESLO_PH\' | translate}}\" data-ng-blur=\"setBlured(\'password2\', true)\" data-ng-focus=\"setBlured(\'password2\', false)\" required />\n      <p data-ng-show=\"formData.heslo != formData.heslo2 && isBlured(\'password2\')\" class=\"help-block\">{{\'SU_REGISTRACE_HESLO_OVERENI_ERROR\' | translate}}</p>\n    </div>\n  </div>\n\n  <div class=\"form-group\">\n    <div class=\"col-xs-12\">\n      <button data-ng-disabled=\"userForm.$invalid\" type=\"submit\" class=\"btn btn-primary\">{{\'SU_REGISTRACE_DOKONCIT\' | translate}}</button>\n    </div>\n  </div>\n</form>\n\n<div class=\"divider horizontal mt50 mb10\"></div>\n<p class=\"text-grey\" custom-block block=\"texts/napoveda\"></p>\n\n<div data-ng-if=\"loading === true\" class=\"preloader-backdrop in\" style=\"display:block\">\n  <div data-ng-if=\"loading === true\" class=\"preloaderBoxWrap in data-ng-scope\">\n    <div data-ng-show=\"loading === true\" class=\"preloaderBox\">\n      <img src=\"/cz.mbc.cezonline.desktop/images/preloader.gif\" alt=\"\">\n    </div>\n  </div>\n  <div class=\"modal-backdrop in\"></div>\n</div>\n</div>");
$templateCache.put("registrace/tmpl/registrace-email-sent.tmpl.html","<div class=\"esco-page registration-page\"><div messages></div>\r\n<div custom-block data-ng-if=\"deaktivateApp !== true && deaktivateApp !== \'true\'\"></div>\r\n<h1 data-ng-if=\"deaktivateApp !== true && deaktivateApp !== \'true\'\"><span class=\"successEmailIco\"></span>E-mail byl odeslán</h1>\r\n<div class=\"row\" data-ng-if=\"deaktivateApp !== true && deaktivateApp !== \'true\'\">\r\n    <div class=\"col-xs-12\">\r\n      <p class=\"lead\">Na e-mailovou adresu <b>{{target}}</b> byl odeslán odkaz pro dokončení registrace. Pokračujte prosím podle instrukcí v tomto e-mailu.</p>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"divider horizontal mt20 mb10\"></div>\r\n<p class=\"text-grey\" custom-block block=\"texts/napoveda\"></p>\r\n</div>");
$templateCache.put("registrace/tmpl/registrace-ok.tmpl.html","<div class=\"esco-page registration-page\">\r\n<div messages></div>\r\n<div custom-block data-ng-if=\"deaktivateApp !== true && deaktivateApp !== \'true\'\"></div>\r\n<h1 data-ng-show=\"!data.customized\" data-ng-if=\"deaktivateApp !== true && deaktivateApp !== \'true\'\"><span class=\"successIco\"></span>{{\'SU_REGISTRACE_SHRNUTI_DEKUJEME\' | translate}}</h1>\r\n<form class=\"form-horizontal\" id=\"okForm\" name=\"okForm\" role=\"form\" method=\"post\" action=\"{{loginData.url}}\" data-ng-if=\"deaktivateApp !== true && deaktivateApp !== \'true\'\">\r\n  <div class=\"form-group\">\r\n    <div class=\"col-xs-12\">\r\n      <p data-ng-show=\"!data.customized\" class=\"lead\">{{\'SU_REGISTRACE_SHRNUTI_REGISTROVANO\' | translate}}</p>\r\n      <p data-ng-show=\"data.customized\" class=\"lead\">{{\'SU_REGISTRACE_SHRNUTI_REGISTROVANO_PND\' | translate}}</p>\r\n    </div>\r\n  </div>\r\n  <div id=\"hidden-fields\">\r\n\r\n    <input type=\"hidden\" value=\"on\" name=\"no_cert_storing\">\r\n    <input type=\"hidden\"value=\"on\" name=\"login_submit\"  >\r\n    <input type=\"hidden\" value=\"1\" name=\"login_do_redirect\">\r\n    <input type=\"hidden\" value=\"default\" name=\"j_authscheme\">\r\n    <input type=\"hidden\" value=\"{{loginData.j_user}}\" name=\"j_username\" id=\"j_user\">\r\n    <input type=\"hidden\" value=\"{{loginData.j_password}}\" name=\"j_password\" id=\"j_password\">\r\n\r\n  </div>\r\n  <div class=\"form-group\">\r\n    <div class=\"col-xs-12\">\r\n      <button data-ng-click=\"login()\" class=\"btn btn-primary\">{{\'SU_REGISTRACE_SHRNUTI_LOGIN\' | translate}}</button>\r\n    </div>\r\n  </div>\r\n</form>\r\n<div data-ng-if=\"loading === true\" class=\"preloader-backdrop in\" style=\"display:block\">\r\n  <div data-ng-if=\"loading === true\" class=\"preloaderBoxWrap in data-ng-scope\">\r\n    <div data-ng-show=\"loading === true\" class=\"preloaderBox\">\r\n      <img src=\"/cz.mbc.cezonline.desktop/images/preloader.gif\" alt=\"\">\r\n    </div>\r\n  </div>\r\n  <div class=\"modal-backdrop in\"></div>\r\n</div>\r\n</div>");
$templateCache.put("registrace/tmpl/registrace-simple.tmpl.html","<div class=\"esco-page registration-page\">\n<div messages></div>\n<h1 data-ng-if=\"deaktivateApp !== true && deaktivateApp !== \'true\'\">{{\'SU_REGISTRACE_LABEL\' | translate}}</h1>\n\n<div custom-block data-ng-if=\"deaktivateApp !== true && deaktivateApp !== \'true\'\"></div>\n\n<form name=\"identificatorForm\" class=\"form-horizontal\" novalidate  data-ng-if=\"deaktivateApp !== true && deaktivateApp !== \'true\'\">\n    <div class=\"form-group\" data-ng-class=\"{ \'has-error\' : userForm.zakaznickeCislo.$invalid && userForm.zakaznickeCislo.$dirty }\">\n        <label for=\"identificator\" class=\"col-xs-12 control-label\">{{\'SU_REGISTRACE_IDENTIFIKATOR\' | translate}}</label>\n\n        <div class=\"col-xs-8\">\n            <input type=\"text\" id=\"identificator\" name=\"identificator\" class=\"form-control\" placeholder=\"{{\'SU_REGISTRACE_IDENTIFIKATOR\' | translate}}\"\n                   data-ng-model=\"data.identificator\" required  data-ng-trim=\"true\"\n                   data-ng-blur=\"setBlured(\'identificator\', true)\" data-ng-focus=\"setBlured(\'identificator\', false)\">\n\n        </div>\n        <small>{{\'SU_REGISTRACE_IDENTIFIKATOR_HELP\' | translate}}</small>\n    </div>\n\n    <div class=\"form-group\">\n        <div class=\"col-xs-12\">\n            <div class=\"checkbox\">\n                <label for=\"souhlas\">\n                    <input type=\"checkbox\" id=\"souhlas\" name=\"souhlas\" data-ng-model=\"souhlas\" required />\n                    <span>{{\'SU_REGISTRACE_SOUHLAS1\' | translate}}<a href=\"https://www.cezesco.cz/cs/podpora/pravidla-provozovani-96770\" target=\"_blank\">{{\'SU_REGISTRACE_SOUHLAS2\' | translate}}</a></span>\n                </label>\n            </div>\n        </div>\n        <div class=\"col-xs-12\">\n            <div class=\"checkbox\">\n                <label for=\"gdpr\">\n                    <input type=\"checkbox\" id=\"gdpr\" name=\"gdpr\" data-ng-model=\"gdpr\" required />\n                    <span>Potvrzuji seznámení s <a href=\"https://www.cezesco.cz/cs/o-nas/informace-o-zpracovani-osobnich-udaju\" target=\"_blank\">Informacemi o zpracování osobních údajů</a></span>\n                </label>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"form-group\">\n        <div class=\"col-xs-12\">\n            <button data-ng-disabled=\"identificatorForm.$invalid\" data-ng-click=\"execCaptcha()\" type=\"button\" class=\"btn btn-primary\">{{\'SU_REGISTRACE_POKRACOVAT\' | translate}}</button>\n        </div>\n    </div>\n</form>\n\n\n<div class=\"divider horizontal mt50 mb10\"></div>\n<p class=\"text-grey\" custom-block block=\"texts/napoveda\"></p>\n\n\n\n<div data-ng-if=\"data.loading === true\" class=\"preloader-backdrop in\" style=\"display:block\">\n    <div class=\"preloaderBoxWrap in data-ng-scope\">\n        <div class=\"preloaderBox\">\n            <img src=\"/cz.mbc.cezonline.desktop/images/preloader.gif\" alt=\"\">\n        </div>\n    </div>\n    <div class=\"modal-backdrop in\"></div>\n</div>\n</div>\n\n\n\n");
$templateCache.put("registrace/tmpl/registrace.tmpl.html","<div class=\"esco-page registration-page\">\r\n<div messages></div>\r\n<div class=\"alert-info\" id=\"loginList\" data-ng-show=\"data.loginList && data.loginList.length > 0\">\r\n    <div data-ng-repeat=\"login in data.loginList track by $index\">{{ login }}</div>\r\n</div>\r\n<h1 data-ng-if=\"deaktivateApp !== true && deaktivateApp !== \'true\'\">{{\'SU_REGISTRACE_LABEL\' | translate}}</h1>\r\n\r\n<div custom-block data-ng-if=\"deaktivateApp !== true && deaktivateApp !== \'true\'\"></div>\r\n\r\n<form name=\"userForm\" class=\"form-horizontal\" novalidate data-ng-submit=\"processForm()\" data-ng-if=\"deaktivateApp !== true && deaktivateApp !== \'true\'\">\r\n    <div class=\"form-group\" data-ng-class=\"{ \'has-error\' : userForm.zakaznickeCislo.$invalid && userForm.zakaznickeCislo.$dirty }\">\r\n        <label for=\"zakaznickeCislo\" class=\"col-xs-12 control-label\">{{\'SU_REGISTRACE_ZAKAZNICKECISLO\' | translate}}</label>\r\n\r\n        <div class=\"col-xs-8\">\r\n            <input type=\"text\" name=\"zakaznickeCislo\" class=\"form-control\" placeholder=\"{{\'SU_REGISTRACE_ZAKAZNICKECISLO\' | translate}}\"\r\n                   data-ng-model=\"formData.zakaznickeCislo\" required data-ng-minlength=\"8\" data-ng-maxlength=\"10\" data-ng-pattern=\"/^\\d+$/\" data-ng-trim=\"true\"\r\n                   data-ng-blur=\"setBlured(\'zakaznickeCislo\', true)\" data-ng-focus=\"setBlured(\'zakaznickeCislo\', false)\">\r\n\r\n            <p data-ng-show=\"userForm.zakaznickeCislo.$error.maxlength && isBlured(\'zakaznickeCislo\')\" class=\"help-block\">{{\'SU_REGISTRACE_ZAKAZNICKECISLO_ERROR_MAX\'\r\n                | translate}}</p>\r\n\r\n            <p data-ng-show=\"userForm.zakaznickeCislo.$error.minlength && isBlured(\'zakaznickeCislo\')\" class=\"help-block\">{{\'SU_REGISTRACE_ZAKAZNICKECISLO_ERROR_MIN\'\r\n                | translate}}</p>\r\n\r\n            <p data-ng-show=\"userForm.zakaznickeCislo.$error.pattern && isBlured(\'zakaznickeCislo\')\" class=\"help-block\">{{\'SU_REGISTRACE_ZAKAZNICKECISLO_ERROR\' |\r\n                translate}}</p>\r\n        </div>\r\n        <small><div custom-block block=\"texts/op_om_napoveda\"></div></small>\r\n    </div>\r\n    <div data-ng-if=\"false && !data.customized\" class=\"form-group\">\r\n        <div class=\"col-xs-12\">\r\n\r\n            <div class=\"radio\">\r\n                <label>\r\n                    <input type=\"radio\" name=\"type\" data-ng-model=\"formData.komodita\" value=\"utility\" required>\r\n                    <span>{{\'SU_REGISTRACE_KOMODITA\' | translate}}</span>\r\n                </label>\r\n            </div>\r\n\r\n            <div class=\"radio\">\r\n                <label>\r\n                    <input type=\"radio\" name=\"type\" data-ng-model=\"formData.komodita\" value=\"mobile\">\r\n                    <span>{{\'SU_REGISTRACE_MOBIL\' | translate}}</span>\r\n                </label>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div data-ng-if=\"formData.komodita == \'utility\' || data.customized\" class=\"form-group\"\r\n         data-ng-class=\"{ \'has-error\' : userForm.cisloOM.$invalid && userForm.cisloOM.$dirty }\">\r\n        <label data-ng-show=\"!data.customized\" for=\"cisloOM\" class=\"col-xs-12 control-label\">{{\'SU_REGISTRACE_CISLOOM\' | translate}}</label>\r\n        <label data-ng-show=\"data.customized\" for=\"cisloOM\" class=\"col-xs-12 control-label\">{{\'SU_REGISTRACE_CISLOOM_CUST\' | translate}}</label>\r\n\r\n        <div class=\"col-xs-8\">\r\n            <input type=\"text\" class=\"form-control\" name=\"cisloOM\" placeholder=\"{{\'SU_REGISTRACE_CISLOOM_PH\' | translate}}\" data-ng-model=\"formData.cisloOM\"\r\n                   data-ng-pattern=\"/([A-Za-z0-9]{20}|[A-Za-z0-9]{16}|\\d{18}|\\d{1,10})/\" data-ng-blur=\"setBlured(\'cisloOM\', true)\" data-ng-focus=\"setBlured(\'cisloOM\', false)\"\r\n                   required>\r\n\r\n            <p data-ng-show=\"userForm.cisloOM.$error.pattern && isBlured(\'cisloOM\') && !data.customized\" class=\"help-block\">{{\'SU_REGISTRACE_KODMISTA_ERROR\' |\r\n                translate}}</p>\r\n\r\n            <p data-ng-show=\"userForm.cisloOM.$error.pattern && isBlured(\'cisloOM\') && data.customized\" class=\"help-block\">{{\'SU_REGISTRACE_KODMISTA_ERROR_PND\' |\r\n                translate}}</p>\r\n        </div>\r\n        <small custom-block block=\"texts/op_om_napoveda\"></small>\r\n    </div>\r\n    <div data-ng-if=\"formData.komodita == \'mobile\'\" class=\"form-group\" data-ng-class=\"{ \'has-error\' : userForm.telefon.$invalid && userForm.telefon.$dirty }\">\r\n        <label for=\"telefon\" class=\"col-xs-12 control-label\">{{\'SU_REGISTRACE_TELEFONSMS\' | translate}}</label>\r\n\r\n        <div class=\"col-xs-8\">\r\n            <input type=\"text\" class=\"form-control\" id=\"telefon\" name=\"telefon\" placeholder=\"{{\'SU_REGISTRACE_TELEFONSMS\' | translate}}\"\r\n                   data-ng-model=\"formData.telefon\" data-ng-pattern=\"/^(\\+\\d{3}\\s?\\d{3}\\s?\\d{3}\\s?\\d{3}|\\d{3}\\s?\\d{3}\\s?\\d{3})$/\" data-ng-blur=\"setBlured(\'telefon\', true)\"\r\n                   data-ng-focus=\"setBlured(\'telefon\', false)\" required/>\r\n\r\n            <p data-ng-show=\"userForm.telefon.$error.pattern && isBlured(\'telefon\')\" class=\"help-block\">{{\'SU_REGISTRACE_TELEFONSMS_ERROR\' | translate}}</p>\r\n        </div>\r\n        <small>{{\'SU_REGISTRACE_TELEFONSMS_INFO\' | translate}}</small>\r\n    </div>\r\n    <div class=\"form-group\" data-ng-class=\"{ \'has-error\' : userForm.loginName.$invalid && userForm.loginName.$dirty }\">\r\n        <label for=\"loginName\" class=\"col-xs-12 control-label\">{{\'SU_REGISTRACE_LOGIN\' | translate}}</label>\r\n\r\n        <div class=\"col-xs-8\">\r\n            <input type=\"text\" name=\"loginName\" id=\"loginName\" class=\"form-control\" placeholder=\"{{\'SU_REGISTRACE_LOGIN\' | translate}}\"\r\n                   data-ng-model=\"formData.loginName\" data-ng-minlength=\"8\" data-ng-maxlength=\"30\" data-ng-pattern=\"/^[a-zA-Z0-9\\._]+$/\" data-ng-blur=\"setBlured(\'loginName\', true)\"\r\n                   data-ng-focus=\"setBlured(\'loginName\', false)\" required/>\r\n\r\n            <p data-ng-show=\"userForm.loginName.$error.minlength && isBlured(\'loginName\')\" class=\"help-block\">{{\'SU_REGISTRACE_LOGIN_ERROR_MIN\' | translate}}</p>\r\n\r\n            <p data-ng-show=\"userForm.loginName.$error.maxlength && isBlured(\'loginName\')\" class=\"help-block\">{{\'SU_REGISTRACE_LOGIN_ERROR_MAX\' | translate}}</p>\r\n\r\n            <p data-ng-show=\"userForm.loginName.$error.pattern && isBlured(\'loginName\')\" class=\"help-block\">{{\'SU_REGISTRACE_LOGIN_ERROR\' | translate}}</p>\r\n        </div>\r\n        <small>{{\'SU_REGISTRACE_LOGIN_INFO\' | translate}}</small>\r\n    </div>\r\n    <div class=\"form-group\">\r\n        <div class=\"col-xs-12\">\r\n            <button data-ng-disabled=\"userForm.$invalid\" type=\"submit\" class=\"btn btn-primary\">{{\'SU_REGISTRACE_POKRACOVAT\' | translate}}</button>\r\n        </div>\r\n    </div>\r\n</form>\r\n\r\n<div class=\"divider horizontal mt50 mb10\"></div>\r\n<p class=\"text-grey\" custom-block block=\"texts/napoveda\"></p>\r\n\r\n<div data-ng-if=\"data.loading === true\" class=\"preloader-backdrop in\" style=\"display:block\">\r\n    <div class=\"preloaderBoxWrap in data-ng-scope\">\r\n        <div class=\"preloaderBox\">\r\n            <img src=\"/cz.mbc.cezonline.desktop/images/preloader.gif\" alt=\"\">\r\n        </div>\r\n    </div>\r\n    <div class=\"modal-backdrop in\"></div>\r\n</div>\r\n</div>\r\n");}]);